var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('span',{staticClass:"md-title"},[_vm._v("Meu ambiente")]),_c('div',{staticClass:"utils"},[_c('md-button',{on:{"click":function($event){return _vm.logout()}}},[_c('md-icon',[_vm._v("exit_to_app")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }